export function fixUnsafeHookFromUserEvent() {
  // [09:58:45.479]     TypeError: Cannot read property 'navigator' of undefined
  // [09:58:45.479]
  // [09:58:45.479]       68630 | }
  // [09:58:45.479]       68631 | function resetClipboardStubOnView(window) {
  // [09:58:45.479]     > 68632 |     if (isClipboardStub(window.navigator.clipboard)) {
  // [09:58:45.479]             |                                ^
  // [09:58:45.479]       68633 |         window.navigator.clipboard[ClipboardStubControl].resetClipboardStub();
  // [09:58:45.479]       68634 |     }
  // [09:58:45.479]       68635 | }
  // [09:58:45.479]
  // [09:58:45.479]       at resetClipboardStubOnView (common.js:68632:32)

  // Patch for @testing-library/user-event
  // Can be removed when this is merged: https://github.com/testing-library/user-event/pull/1178

  globalThis.window = globalThis.window || ({} as any);
  globalThis.window.navigator = globalThis.window.navigator || ({} as any);
}
